import React from 'react';
import debounce from 'debounce';

const useEnterSubmit = (onSubmit: (() => void) | undefined, canSubmit: boolean | undefined) =>
  React.useMemo(
    () => debounce((event: React.KeyboardEvent<HTMLInputElement>) => {
      if (event.key === 'Enter' && canSubmit) {
        onSubmit?.();
      }
    }, 200),
    [canSubmit, onSubmit],
  );

export default useEnterSubmit;
